import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'

import { TableHelper } from '../../../../tables'

import { ContestTable } from '../../../../tables/contest-table'

const ScheduledContests: React.FunctionComponent = observer(() => {
  const { contestStore } = useStores()
  const { setTriggerRefresh, triggerRefresh } = contestStore

  const [tableHelper] = useState(
    new TableHelper('list_scheduled_contests', 'contests', 'contests', undefined, 'scheduled'),
  )

  useEffect(() => {
    if (triggerRefresh) {
      tableHelper.load().then(() => setTriggerRefresh(false))
    }
    return () => {
      setTriggerRefresh(undefined)
    }
  }, [triggerRefresh])

  return <ContestTable forceLoading={triggerRefresh} filter="scheduled" tableHelper={tableHelper} />
})

export const ScheduledContestsTab = () => {
  return {
    name: 'Scheduled',
    path: `/activities/contests/scheduled`,
    component: () => <ScheduledContests />,
  }
}
